import React, { useState } from "react";
import "./Footer.css";
import logo from "../components/Images/Coloredd.png"; // adjust if needed

export default function Footer() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null); // null | "ok" | "err"

  const year = new Date().getFullYear();

  const onSubmit = (e) => {
    e.preventDefault();
    // very simple check; replace with your EmailJS/Supabase action
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setSent("err");
      return;
    }
    setSent("ok");
    setEmail("");
  };

  return (
    <footer className="kp-footer" role="contentinfo">
      <div className="kp-footer-wrap">
        {/* Brand + short value */}
        <div className="kp-foot-brand">
          <a href="#top" className="kp-foot-logo">
            <img src={logo} alt="KostPadi" />
          </a>
          <p className="kp-foot-tagline">
            A modern ERP-style finance suite for SMEs—estimate costs, invoice
            faster, and see your cash flow clearly, all in one secure workspace.
          </p>

          {/* Contact summary */}
          <ul className="kp-foot-contact">
            <li>
              <a href="mailto:hello@kostpadi.com">hello@kostpadi.com</a>
            </li>
            <li>
              <a href="tel:+234-903-198-6790">+234 (903) 198 6790</a>
            </li>
            <li>Lagos, Nigeria • Mon–Fri 9am–6pm WAT</li>
          </ul>

          {/* Socials */}
          <div className="kp-foot-socials" aria-label="Social links">
            <a
              href="https://www.linkedin.com/company/kostpadi-limited/"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              {iconLinkedIn}
            </a>
            <a href="https://x.com" aria-label="Twitter/X" title="Twitter/X">
              {iconX}
            </a>
            <a href="https://youtube.com" aria-label="YouTube" title="YouTube">
              {iconYouTube}
            </a>
            <a
              href="https://instagram.com"
              aria-label="Instagram"
              title="Instagram"
            >
              {iconInstagram}
            </a>
          </div>
        </div>

        {/* Link columns */}
        <nav className="kp-foot-cols" aria-label="Footer navigation">
          <div className="kp-foot-col">
            <h4>Product</h4>
            <ul>
              <li>
                <a href="#features">Features</a>
              </li>
              <li>
                <a href="#get-started">Pricing</a>
              </li>
              <li>
                <a href="#features">Invoicing</a>
              </li>
              <li>
                <a href="#features">Cost Estimation</a>
              </li>
              <li>
                <a href="#features">Accounting & Reports</a>
              </li>
            </ul>
          </div>
          <div className="kp-foot-col">
            <h4>Company</h4>
            <ul>
              <li>
                <a href="/about">About</a>
              </li>
              <li>
                <a href="/">Careers</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
              <li>
                <a href="/">Partners</a>
              </li>
              <li>
                <a href="/">Press Kit</a>
              </li>
            </ul>
          </div>
          <div className="kp-foot-col">
            <h4>Resources</h4>
            <ul>
              <li>
                <a href="/docs-guides">Docs & Guides</a>
              </li>
              <li>
                <a href="/api-reference">API Reference</a>
              </li>
              <li>
                <a href="/templates">Templates</a>
              </li>
              <li>
                <a href="/status">Status</a>
              </li>
              <li>
                <a href="/changelog">Changelog</a>
              </li>
            </ul>
          </div>
          <div className="kp-foot-col">
            <h4>Legal</h4>
            <ul>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms-of-service">Terms of Service</a>
              </li>
              <li>
                <a href="/data-processing">Data Processing</a>
              </li>
              <li>
                <a href="/security">Security</a>
              </li>
              <li>
                <a href="/cookies">Cookies</a>
              </li>
            </ul>
          </div>
        </nav>

        {/* Newsletter + selectors */}
        <div className="kp-foot-news">
          <h4>Stay in the loop</h4>
          <p>
            Monthly product updates, tips, and finance best practices. No spam.
          </p>
          <form className="kp-foot-form" onSubmit={onSubmit}>
            <input
              type="email"
              placeholder="you@company.com"
              aria-label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button className="btn btn-primary" type="submit">
              Subscribe
            </button>
          </form>
          {sent === "ok" && (
            <p className="kp-foot-success">Thanks! You’re on the list.</p>
          )}
          {sent === "err" && (
            <p className="kp-foot-error">Enter a valid email to subscribe.</p>
          )}

          <div className="kp-foot-selects">
            <label>
              <span>Language</span>
              <select aria-label="Language">
                <option>English (NG)</option>
                <option>English (US)</option>
                <option>Français</option>
              </select>
            </label>
            <label>
              <span>Theme</span>
              <select aria-label="Theme">
                <option>System</option>
                <option>Dark</option>
                <option>Light</option>
              </select>
            </label>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="kp-foot-bottom">
        <div className="kp-foot-bottom-inner">
          <span>© {year} KostPadi. All rights reserved.</span>
          <div className="kp-foot-bottom-links">
            <a href="/">Privacy</a>
            <a href="/">Terms</a>
            <a href="/">Security</a>
            <button
              className="kp-back-to-top"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              Back to top
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* --- Inline SVG Icons --- */
const iconLinkedIn = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6.94 8.5H3.5v12h3.44v-12ZM5.22 3.5a2.01 2.01 0 1 0 0 4.02 2.01 2.01 0 0 0 0-4.02ZM20.5 20.5h-3.42v-6.45c0-1.54-.03-3.52-2.14-3.52-2.14 0-2.47 1.67-2.47 3.41v6.56h-3.42v-12h3.28v1.64h.05c.46-.88 1.58-1.8 3.25-1.8 3.48 0 4.12 2.29 4.12 5.26v6.9Z"
      fill="currentColor"
    />
  </svg>
);

const iconX = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M14.7 4h3.2L13.2 10l5.1 7h-3.9l-2.8-3.9-3.4 3.9H5l5.1-5.8L5.3 4h3.9l2.5 3.5L14.7 4Z"
      fill="currentColor"
    />
  </svg>
);

const iconYouTube = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M23 12s0-3.2-.41-4.63a3.1 3.1 0 0 0-2.19-2.19C18.97 4.77 12 4.77 12 4.77s-6.97 0-8.41.41A3.1 3.1 0 0 0 1.4 7.37C1 8.8 1 12 1 12s0 3.2.41 4.63c.27.99 1.07 1.78 2.06 2.06 1.44.41 8.53.41 8.53.41s6.97 0 8.41-.41a3.1 3.1 0 0 0 2.19-2.19C23 15.2 23 12 23 12Zm-13.6 3.2v-6.4l6.13 3.2-6.13 3.2Z"
      fill="currentColor"
    />
  </svg>
);

const iconInstagram = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0-3.5c1.35 0 1.52.01 2.06.03.53.03.9.1 1.22.21.33.12.61.27.89.55.28.28.43.56.55.89.11.32.18.69.21 1.22.02.54.03.71.03 2.06s-.01 1.52-.03 2.06c-.03.53-.1.9-.21 1.22-.12.33-.27.61-.55.89-.28.28-.56.43-.89.55-.32.11-.69.18-1.22.21-.54.02-.71.03-2.06.03s-1.52-.01-2.06-.03c-.53-.03-.9-.1-1.22-.21a2.2 2.2 0 0 1-.89-.55c-.28-.28-.43-.56-.55-.89-.11-.32-.18-.69-.21-1.22A48 48 0 0 1 6.5 12c0-1.35.01-1.52.03-2.06.03-.53.1-.9.21-1.22.12-.33.27-.61.55-.89.28-.28.56-.43.89-.55.32-.11.69-.18 1.22-.21C10.48 6.5 10.65 6.5 12 6.5Z"
      fill="currentColor"
    />
    <circle cx="17.35" cy="6.65" r="1.2" fill="currentColor" />
  </svg>
);
